import type {
	NavigationRoutes
} from "~/types/global";

export const globalStores = () => {
	const ALLOW_API_CALLS = useState<boolean>( "allow-api-calls", () => true );
	const MAX_DESKTOP_WIDTH = useState<number>( "max-desktop-width", () => 1024 );
	const ROUTES = useState<NavigationRoutes>( "navigation-routes", () => {
		return {
			base: "/",
			home: "/home",
			dressCode: "/dress-code",
			gallery: "/gallery",
			weddingParty: "/wedding-party",
			qAndA: "/q-and-a",
			travel: "/travel",
			thingsToDo: "/things-to-do",
			registry: "/registry",
			rsvp: "/rsvp"
		};
	} );

	return {
		ALLOW_API_CALLS,
		MAX_DESKTOP_WIDTH,
		ROUTES
	};
};